/** The Maker portal's green "A", with the portal's name on the sign-in card or the market maker's in the sidebar. */
export function Brand({ name, sub, size = "lg", mark = null }: { name: string; sub: string; size?: "lg" | "sm"; mark?: string | null }) {
  return (
    <div className={size === "sm" ? "brand brand-sm" : "brand"}>
      <span className="brand-logo" aria-hidden="true">
        A
      </span>
      <span className="brand-text">
        <span className="brand-name-line">
          <span className="brand-name" title={name}>
            {name}
          </span>
          {mark !== null && <span className="brand-mark">{mark}</span>}
        </span>
        <span className="brand-sub">{sub}</span>
      </span>
    </div>
  );
}
